export default __webpack_public_path__ + "static/media/icon-castro.ab3d7a3b.svg";